import * as React from 'react';
import classnames from 'classnames';

import { expandDataProps } from 'utils/helper/common';

import type { Data } from 'types';

type Props = {
  name: string,
  label: React.ReactNode,
  isSelected: boolean,
  isDisabled: boolean,
  onClick: (event: React.MouseEvent<HTMLDivElement>) => void,
  data?: Data
};

class DeliverableTab extends React.PureComponent<Props> {
  render() {
    const { name, label, isSelected, isDisabled, onClick, data } = this.props;

    const tabClasses = classnames({
      'deliverable-tab': true,
      'deliverable-tab--selected': isSelected,
      'deliverable-tab--disabled': isDisabled
    });

    return (
      <section
        data-tab={name}
        className={tabClasses}
        onClick={isSelected ? undefined : onClick}
        {...expandDataProps(data)}
      >
        {label}
      </section>
    );
  }
}

export default DeliverableTab;
